export const regionsBlocked = ['USA','CAN','CAR','CAM','SUD','SUDLH','SUDSH','SH','EUR','ASI']

export const regions = {
    ASI: {
        es: 'Asia',
        other: 'Asia'
    },
    CAM: {
        es: 'Centroamérica',
        other: 'Central America'
    },
    CAN: {
        es: 'Canadá',
        other: 'Canada'
    },
    CAR: {
        es: 'Caribe',
        other: 'Caribbean'
    },
    EUR: {
        es: 'Europa',
        other: 'Europe'
    },
    SUD: {
        es: 'Sudamérica',
        other: 'South America'
    },
    USA: {
        es: 'Estados Unidos',
        other: 'United States'
    },
    SUDLH: {
        es: 'Sudamérica - Larga distancia',
        other: 'South America - Long Haul'
    },
    SUDSH: {
        es: 'Sudamérica - Corta/Media distancia',
        other: 'South America - Short Haul'
    },
    SH: {
        es: 'Corta/Media distancia',
        other: 'Short Haul'
    },
}

export const regionsSouthAmerica = ['SUD', 'SUDLH', 'SUDSH', 'SH'];

export const REGION_SOUTH_AMERICA = {
    es: 'Sudamérica',
    other: 'South America'
};